export const statuses = {
  open: 'Aberto',
  finished: 'Faturado',
};

export function getName(value) {
  return statuses[value];
}
